import axios from 'axios';
import { getCookie } from 'config/Axios/AxiosInstanceConfigs';
import { tokenTypes } from 'utils/AuthUtils/tokenUtils';

let apiBaseUrl;
if (import.meta.env.VITE_MODE == 'dev') {
  apiBaseUrl = import.meta.env.VITE_BACKEND_ENDPOINT;
} else {
  apiBaseUrl = window.config.apiBaseUrl;
}

// Pull the filename out of a Content-Disposition header. Backend sends
// `attachment; filename="Provisional_Forecast_2026-05-01.xlsx"` — we
// honour that so multiple exports in one session don't collide in the
// user's Downloads folder. Falls through to `fallback` if the header
// is absent (older backends) or unparseable.
const parseFilenameFromContentDisposition = (
  header: string | undefined,
  fallback: string
): string => {
  if (!header) return fallback;
  const quoted = header.match(/filename\*?="?([^";]+)"?/i);
  if (quoted && quoted[1]) {
    try {
      return decodeURIComponent(quoted[1].trim());
    } catch {
      return quoted[1].trim();
    }
  }
  return fallback;
};

const triggerXlsxDownload = (
  blobPayload: BlobPart,
  contentDisposition: string | undefined,
  fallbackFilename: string
): void => {
  const blob = new Blob([blobPayload], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const filename = parseFilenameFromContentDisposition(contentDisposition, fallbackFilename);
  const link = document.createElement('a');
  const objectUrl = URL.createObjectURL(blob);
  link.href = objectUrl;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(objectUrl);
};

export const provisonalForecastScreenServices = {
  downloadAllProvisionalForecastExcelFile: (): Promise<{ success: boolean }> => {
    return new Promise(async (resolve, reject) => {
      const token = localStorage.getItem(tokenTypes.access) || '';
      const csrfToken = getCookie('csrftoken');

      // `apiBaseUrl` already ends with `/` in dev (`VITE_BACKEND_ENDPOINT`)
      // and may or may not in deployed envs (`window.config.apiBaseUrl`).
      // Strip any trailing slash before joining so we never emit a
      // double-slashed URL — Django returns 404 on `//fdp/...`.
      const base = apiBaseUrl.replace(/\/+$/, '');
      const apiURL = `${base}/fdp/get_excel_active_all_provision_forecast_data`;
      try {
        const response = await axios({
          url: apiURL,
          method: 'POST',
          responseType: 'blob',
          headers: {
            'X-CSRFToken': csrfToken,
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });

        triggerXlsxDownload(
          response.data,
          response.headers?.['content-disposition'],
          'Provisional_Forecast.xlsx'
        );

        resolve({ success: true });
      } catch (error) {
        reject(error);
      }
    });
  },
};
